import { useQuery } from '@tanstack/react-query'
import { api } from '../services/api'
import { useAppLaunch } from '../hooks/useAppLaunch'

interface AppAccess {
  access_id: string
  application: {
    id: string
    app_id: string
    name: string
    description: string | null
    url: string
    is_active: boolean
  }
  granted_at: string | null
}

export function Apps() {
  const { launchApp } = useAppLaunch()

  const { data: apps, isLoading, error } = useQuery({
    queryKey: ['apps'],
    queryFn: () => api.get<AppAccess[]>('/apps'),
  })

  return (
    <div className="max-w-4xl">
      <h1 className="text-3xl mb-8">Apps</h1>

      {isLoading ? (
        <p className="text-[var(--color-text-secondary)]">Loading...</p>
      ) : error ? (
        <p className="text-red-400">Failed to load apps</p>
      ) : apps && apps.length > 0 ? (
        <div className="grid gap-4 sm:grid-cols-2">
          {apps.map((app) => (
            <div key={app.access_id} className="card">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="text-lg mb-1">{app.application.name}</h3>
                  {app.application.description && (
                    <p className="text-sm text-[var(--color-text-secondary)]">
                      {app.application.description}
                    </p>
                  )}
                </div>
                <span className="text-2xl">🚀</span>
              </div>
              <button
                onClick={() => launchApp(app.access_id)}
                className="btn btn-primary mt-4 w-full"
              >
                Launch App
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="card">
          <p className="text-[var(--color-text-secondary)]">
            No apps available. Contact your administrator for access.
          </p>
        </div>
      )}
    </div>
  )
}
